const state = {
  notes: []
}

export default state
